import { useTranslation } from 'react-i18next';

import logo from '@assets/logos/astropay-logo.png';
import { APImage } from '@components/atoms/APImage';
import { Typography } from '@components/atoms/Typography';

import { TCheckoutHeaderProps } from './types';

export const CheckoutHeader = ({ productName }: TCheckoutHeaderProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-row justify-center w-full p-2 mb-4 md:px-16 md:py-8">
      <APImage img={logo} width={114} height={29} alt={t('AstroPayDownload.title')} />

      <Typography
        text={t(productName)}
        weight={400}
        className="ml-1 text-[26px] leading-none tracking-wide text-[#059985]"
        variant="span"
      />
    </div>
  );
};
